/**
 * @generated SignedSource<<3754a133560d3cad44f3683f7d011fba>>
 * @relayHash 8e0b57fc78588fab5ce6e2ba76089a61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 00dfb7b57058946faf78573ea5754789e6b3e2dd7eab0b5c0a813c3db15e260b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_jiraBusinessFormQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type src_jiraBusinessFormQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly " $fragmentSpreads": FragmentRefs<"ProjectContextProvider">;
    } | null | undefined;
  } | null | undefined;
};
export type src_jiraBusinessFormQuery = {
  response: src_jiraBusinessFormQuery$data;
  variables: src_jiraBusinessFormQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v2 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "src_jiraBusinessFormQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ProjectContextProvider"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "src_jiraBusinessFormQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "projectId"
              },
              {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "large"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "projectType"
              },
              {
                "kind": "ScalarField",
                "name": "status"
              },
              {
                "kind": "ScalarField",
                "name": "projectStyle"
              },
              {
                "kind": "ScalarField",
                "name": "isFavourite"
              },
              {
                "alias": "assignIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "ASSIGN_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": "action(type:\"ASSIGN_ISSUES\")"
              },
              {
                "alias": "administerProject",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
              },
              {
                "alias": "createIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "CREATE_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": "action(type:\"CREATE_ISSUES\")"
              },
              {
                "alias": "deleteIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "DELETE_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": "action(type:\"DELETE_ISSUES\")"
              },
              {
                "alias": "editIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": "action(type:\"EDIT_ISSUES\")"
              },
              {
                "alias": "linkIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "LINK_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": "action(type:\"LINK_ISSUES\")"
              },
              {
                "alias": "scheduleIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "SCHEDULE_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
              },
              {
                "alias": "transitionIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "TRANSITION_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": "action(type:\"TRANSITION_ISSUES\")"
              },
              {
                "alias": "viewIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": "action(type:\"VIEW_ISSUES\")"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "00dfb7b57058946faf78573ea5754789e6b3e2dd7eab0b5c0a813c3db15e260b",
    "metadata": {},
    "name": "src_jiraBusinessFormQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4a44486d377d3a1bdfddc09fee9e13d1";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
